import { $httpRootApi } from '@core/http-client';

import { UserNotificationStatePayload } from './notificationsApi.types';

export const notificationsMutations = {
  dismiss: async (payload: UserNotificationStatePayload) =>
    $httpRootApi.post(`/user/notifications/${payload.id}/dismiss`),
  read: async (payload: UserNotificationStatePayload) => $httpRootApi.post(`/user/notifications/${payload.id}/read`),
};
